import React, { FC, ReactElement } from 'react'
import { Button, useMediaQuery, useTheme } from '@material-ui/core'
import RenderIf from '@components/RenderIf'
import useStyles from './styles'

interface IOptionProps {
  id: string;
  label: string;
  currentTab: string;
  icon: ReactElement;
  disabled: boolean;
  setCurrentTab: (id: string) => void;
  onOptionClick?: () => void;
}

const Option: FC<IOptionProps> = ({ id, label, currentTab, icon, setCurrentTab, onOptionClick, disabled }) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const handleClickOption = () => {
    setCurrentTab(id)
    if (onOptionClick) onOptionClick()
  }

  return (
    <Button
      className={`${classes.option} ${currentTab === id ? 'active' : ''}`}
      onClick={handleClickOption}
      disabled={disabled}
    >
      <div className={classes.optionContent}>
        <RenderIf condition={!isMobile}>
          <>
            {icon}
          </>
        </RenderIf>
        {label}
      </div>
    </Button>
  )
}

export default Option
